<template>
    <div id="product-advantages" class="slider" style="user-select: none">
        <p v-for="item in items">
            <span>
                <i class="icon-cr " :class="[item.icon]"></i>
                &nbsp;{{item.label}}
            </span>
        </p>
    </div>
</template>

<script>
    import Slider from "../../../common/hammer-slider";

    export default {
        name: "ProductAdvantages",

        data() {
            const data = {items: []};

            if (this.$scope.is_prime) {
                data.items.push({
                    icon: 'icon-carrier',
                    label: 'Leve agora com frete grátis!'
                });
            } else if (this.$scope.CONFIG.FRETE_VALOR_FIXO_HABILITADO && this.$scope.CONFIG.FRETE_VALOR_FIXO == 0) {
                data.items.push({
                    icon: 'icon-carrier',
                    label: `Frete grátis em qualquer compra. Aproveite!`
                });
            } else {
                data.items.push({
                    icon: 'icon-carrier',
                    label: `Frete grátis em pedidos acima de R$ ${this.$scope.CONFIG.VALOR_FRETE_GRATIS}`
                });
            }

            data.items.push({
                icon: 'icon-exchange',
                label: 'Sua 1ª troca no site é grátis'
            });

            return data;
        },

        mounted() {
            new Slider('#product-advantages').init({
                orientation: 'vertical',
                loop: true,
                adaptOnResize: false,
                enableBullets: false,
                autoplayInterval: 3000,
                enableGestures: false
            });
        }
    }
</script>